import React from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import ReactPlayer from "react-player";
import MyStorage from "./util/storage";

const PlayVideo = () => {
  let filePath = MyStorage.getFileUrls().LibraryVideos;
  const location = useLocation();
  let model = location.state.model;
  console.log("url: " + model.file_name);

  return (
    <div className="main">
      {model.title}
      <ReactPlayer
        style={{ marginTop: 10 }}
        url={model.file_name}
        playing={true}
        controls={true}
      />
    </div>
  );
};

export default PlayVideo;
